export default {"src":"/_next/static/media/cxAssortments.831f14f0.svg","height":455,"width":740,"blurWidth":0,"blurHeight":0};